module.exports = __webpack_public_path__ + "static/media/monthlyPLAnalaysis_ja_dark.99c71694.png";